import * as types from "../types/task.invoice.types";

const initialState = {
  taskInvoiceDetailData: []
};

const TaskInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TASK_INVOICE_DETAIL_DATA:
      return { ...state, taskInvoiceDetailData: action.payload };
    case types.RESET_TASK_INVOICE_REDUCER:
      return {
        ...state,
        taskInvoiceDetailData: [],
      };
    default:
      return state;
  }
};

export default TaskInvoiceReducer;